function fn_comp_encyclopedia_references() {
    var $fn = $(".comp_encyclopedia, .comp_references");

    if($fn.length){
        var $color = $(".elm_categories .mod--active").data("color");

        $fn.find(".elm_categories").addClass("mod--"+$color);
        $fn.find(".elm_content").addClass("mod--"+$color);

        $fn.on("click","[data-link]",function (e) {
            e.preventDefault();
            loadArticle($(this));
            $('html, body').animate({
                scrollTop: $(this).parents(".elm_entries").offset().top - 150
            }, 500);
        });

        $fn.on("change",".elm_entries select",function () {
            loadArticle($("option:selected",this));
        });

        function loadArticle(link){
            var $this = link;
            $("[data-link]").removeClass("mod--active");
            $this.addClass("mod--active");
        }
    }
}